import { AGGREGATE_NAMES, TEMPLATE_RESOLVERS } from 'cpool-constants';
import { schemaTemplateResolver_GetOfferTemplates } from 'cpool-tables/backend-resolvers';

import { useAggregateQuery } from '~/queryUtils/useQuery';

export const useOfferTemplateList = () => {
    return useAggregateQuery({
        acl: {},
        aggregateName: AGGREGATE_NAMES.TEMPLATE,
        resolverName: TEMPLATE_RESOLVERS.getOfferTemplates,
        schema: schemaTemplateResolver_GetOfferTemplates,
    });
};
